<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
   
    <div class="main-content">
    
    <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
    @if(loaderIcon | async){
        <app-loader ></app-loader>
    }
    @if (!EditOrCreate()) {
        <div class="content-area" >
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Email Templates</h5>
                <div class="col-6 text-end mt-2 mb-3">
                    <button class="btn btnAS me-1" [userPermissionHandler]="createPermissionHandlerData"  (click)="ShowCreateOrEdit()">NEW</button>
                </div>
            </div>
            <hr />
            <div class="row" [userPermissionHandler]="viewPermissionHandlerData">
                  <ejs-grid 
                        #gridEmailTemplate
                        [dataSource]="EmailTemplateList"
                        height="auto"
                        allowFiltering="true"
                        allowSelection="false"
                        [enableVirtualization]="false"
                        allowTextWrap="true"
                        (load)="load()"
                        (rowSelected)="RowChange($event)"
                        gridLines="Horizontal"
                        class="custom-grid">
                            <e-columns>
                               
                                <e-column field="TemplateName" headerText="Template Name" width='150'></e-column>
                                <e-column field="TemplateType" headerText="Template Type" width='120'></e-column>
                                <e-column field="BaseTemplate" headerText="Base Template" width='130' ></e-column>
                                
                                <e-column field="Delete" headerText="Delete"  [allowFiltering]="false" [allowSorting]="false" textAlign="Center" width='100' >
                                    <ng-template  #template let-data >
                                            <button class="btn btnAS" [userPermissionHandler]="deletePermissionHandlerData" (click)="deleteEmailTemplate(data)"  style="background-color: transparent;border: none;" >
                                                <img src="./assets/images/delete.svg" class="img-fluid" />
                                            </button>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>

            </div>
        </div>
    } @else{
    <app-ops-neworedit-email-template [templateData]="selectedTemplate"  (close)="HideCreateOrEdit()"></app-ops-neworedit-email-template>
    }
    </div>
</div>

